export default [{
    title: 'Asc',
    fontIcon: 'calculator', // TODO: Change ASC menu Icon
    resource: 'Control ASC',
    action: 'ver-control-asc',
    children: [{
            title: 'Gestion de lotes',
            icon: 'ClipboardIcon',
            children: [{
                    route: 'control-asc-lotes-asc',
                    title: 'Lotes ASC',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-lotes',
                },
                {
                    title: 'Lotes Frescos',
                    route: 'control-asc-lotes-fresco',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-aprobacion-lotes',
                },
                {
                    title: 'Lotes Valor Agregado',
                    route: 'control-asc-lotes-va',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-aprobacion-lotes-va',
                },
                {
                    title: 'Lotes Reproceso',
                    route: 'control-asc-lotes-rp',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-aprobacion-lotes-rp',
                },
            ],
        },
        {
            title: 'Control de Movimientos',
            fontIcon: 'exchange-alt', // TODO: Change icon
            resource: 'Control ASC',
            action: 'ver-control-asc-movimientos',
            children: [{
                    route: 'control-asc-lotes-ingresos',
                    title: 'Ingresos ASC',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-lotes-ingresos',
                },
                {
                    route: 'control-asc-lotes-egresos',
                    title: 'Egresos ASC',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-lotes-egresos',
                },
            ],
        },
        {
            title: 'Reportes',
            resource: 'Control ASC',
            fontIcon: 'file-prescription',
            action: 'ver-control-asc-reportes',
            children: [{
                    route: 'control-asc-reportes-lotes',
                    title: 'Reporte Por Lote',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-reportes-saldo-lotes',
                },
                {
                    route: 'control-asc-reportes-items',
                    title: 'Reporte Por Items',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-reportes-saldo-items',
                },
                {
                    title: 'Embarque',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-reportes-embarque',
                    children: [{
                            route: 'control-asc-reportes-embarque-x-tipo',
                            title: 'Por tipo',
                            action: 'ver-control-asc-reportes-embarque-x-tipo',

                        },
                        {
                            route: 'control-asc-reportes-embarque-x-lote',
                            title: 'Por Lotes',
                            action: 'ver-control-asc-reportes-embarque-x-lote',

                        },
                    ],
                },
                {
                    route: 'control-asc-reportes-balance-masa',
                    title: 'Reporte Por Balance de Masa',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-reportes-balance-masa',
                },
                {
                    route: 'control-asc-reporets-recepcion-pesca',
                    title: 'Recepción de Pesca',
                    resource: 'Control ASC',
                    action: 'ver-control-asc-reportes-recepcion-pesca',
                },
            ],

        },
    ],
}]